import liveViewTutorial from './liveViewTutorial';
import monitoringTutorial from './monitoringTutorial';
import accessControlTutorial from './accessControlTutorial';
import recordingAssuranceTutorial from './recordingAssuranceTutorial';
import discoveryTutorial from './discoveryTutorial';
import settingsTutorial from './settingsTutorial';
import archivePlaybackTutorial from './archivePlaybackTutorial';
import intercomsTutorial from './intercomsTutorial';
import monitoredDevicesTutorial from './monitoredDevicesTutorial';
import switchesTutorial from './switchesTutorial';
import operationsTutorial from './operationsTutorial';
import credentialsTutorial from './credentialsTutorial';
import healthTutorial from './healthTutorial';
import reportsTutorial from './reportsTutorial';
import mapTutorial from './mapTutorial';
import entryFleetTutorial from './entryFleetTutorial';
import entryProfilesTutorial from './entryProfilesTutorial';
import videoWallTutorial from './videoWallTutorial';
import notificationsTutorial from './notificationsTutorial';
import auditLogTutorial from './auditLogTutorial';
import accessReviewTutorial from './accessReviewTutorial';
import registrationTutorial from './registrationTutorial';
import adminSettingsTutorial from './adminSettingsTutorial';
import platformAdminTutorial from './platformAdminTutorial';
import shabbatTutorial from './shabbatTutorial';
import investigationsTutorial from './investigationsTutorial';

export const allTutorials = [
  liveViewTutorial,
  monitoringTutorial,
  accessControlTutorial,
  recordingAssuranceTutorial,
  discoveryTutorial,
  settingsTutorial,
  archivePlaybackTutorial,
  intercomsTutorial,
  monitoredDevicesTutorial,
  switchesTutorial,
  operationsTutorial,
  credentialsTutorial,
  healthTutorial,
  reportsTutorial,
  mapTutorial,
  entryFleetTutorial,
  entryProfilesTutorial,
  videoWallTutorial,
  notificationsTutorial,
  auditLogTutorial,
  accessReviewTutorial,
  registrationTutorial,
  adminSettingsTutorial,
  platformAdminTutorial,
  shabbatTutorial,
  investigationsTutorial,
];

export {
  liveViewTutorial,
  monitoringTutorial,
  accessControlTutorial,
  recordingAssuranceTutorial,
  discoveryTutorial,
  settingsTutorial,
  archivePlaybackTutorial,
  intercomsTutorial,
  monitoredDevicesTutorial,
  switchesTutorial,
  operationsTutorial,
  credentialsTutorial,
  healthTutorial,
  reportsTutorial,
  mapTutorial,
  entryFleetTutorial,
  entryProfilesTutorial,
  videoWallTutorial,
  notificationsTutorial,
  auditLogTutorial,
  accessReviewTutorial,
  registrationTutorial,
  adminSettingsTutorial,
  platformAdminTutorial,
  shabbatTutorial,
  investigationsTutorial,
};
